import {FC} from "react";
import styled from "styled-components";
import {CategoryInfoFragment} from "./__generated__/CategoryInform.fragment.generated";


const Container = styled.div`
  padding: 2.4rem;
  line-height: 130%;
  margin-top: -2.4rem;
  margin-left: -2.4rem;
  background: #e6ebef;
  margin-bottom: 2.5rem;
  width: calc(100% + 4.8rem);
`;


interface CategoryInformProps {
  info: CategoryInfoFragment
}

const CategoryInform:FC<CategoryInformProps> = ({ info }) => {
  return (
      <Container>
        <p>Информация о категории:</p>
        <h2>{info.name}</h2>
        <p>Url: {info.url}</p>
      </Container>
  )
}

export default CategoryInform;
